import React, { useCallback } from 'react';

import {
	Button,
	Modal,
	Space,
	Title,
} from '@components';

import {
	ConvertedDialogueAct,
} from '@common';

import './DeleteDialogueActModal.scss';

interface DeleteDialogueActModalProps {
	onSubmit: (updatedDialogueAct: ConvertedDialogueAct) => void,
	dialogueAct: ConvertedDialogueAct,
	closeModal: () => void,
}

function DeleteDialogueActModal(props: DeleteDialogueActModalProps): JSX.Element {
	const {
		dialogueAct,
		closeModal,
		onSubmit,
	} = props;

	const handleSubmit = useCallback(() => {
		onSubmit(dialogueAct);
		closeModal();
	}, [onSubmit, closeModal, dialogueAct]);

	return (
		<Modal
			className="delete-dialogue-act-modal"
			isOpen
		>
			<Space alignment="vertical">
				<Title centered>
					Удалить выбранный блок?
				</Title>
				<Space alignment="vertical" gap="20px">
					{/* LATER: text component */}
					<div>
						После удаления восстановить блок невозможно
					</div>
					<Space centered>
						<Button theme="primary" onClick={handleSubmit}>
							Удалить
						</Button>
						<Button onClick={closeModal}>
							Отменить
						</Button>
					</Space>
				</Space>
			</Space>
		</Modal>
	);
}

export {DeleteDialogueActModal};